const headerData = [
  {
    title: "Why use Sohbet?",
    subTitle:
      "Explore below to see why Sohbet is a simple, powerful, and secure messenger",
  },
];

const bodyData = [
  {
    title: "Share Without Insecurity",
    subTitle:
      "State-of-the-art end-to-end encryption (powered by the open source Sohbet Protocol) keeps your conversations secure. We can't read your messages or listen to your calls, and no one else can either. Privacy isn’t an optional mode — it’s just the way that Sohbet works. Every message, every call, every time.",
  },
];

export { headerData, bodyData };
